import Reveal from './Reveal';
import PhoneMockup from './PhoneMockup';
import AppStoreButton from './AppStoreButton';
import { DiscoverIcon, ShareIcon, ReactIcon } from './icons';
import screen4 from '../assets/images/screen_4.png';
import './Features.css';

const FEATURES = [
  {
    icon: DiscoverIcon,
    title: 'Discover together',
    body: 'Browse popular movies and shows, then see exactly what your friends and family are recommending right now.',
  },
  {
    icon: ShareIcon,
    title: 'Share your favorites',
    body: 'Recommend the titles you love, drop a comment, and let everyone know what made you laugh, cry, or stay up all night.',
  },
  {
    icon: ReactIcon,
    title: 'React and connect',
    body: 'Record and share video reactions, reply to recommendations, and turn watching into something you do together.',
  },
];

export default function Features() {
  return (
    <section className="features section" id="features">
      <div className="container">
        <Reveal className="section-head">
       
          <h2 className="section-title">
            Finding your next watch should feel like asking a friend.
          </h2>
          <p className="section-sub">
            Peek turns movie night into a social experience powered by the
            people you trust and an AI that gets your taste.
          </p>
        </Reveal>

        <div className="features__grid">
          {FEATURES.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <Reveal key={feature.title} className="feature-card" delay={i * 90}>
                <span className="feature-card__icon">
                  <Icon />
                </span>
                <h3 className="feature-card__title">{feature.title}</h3>
                <p className="feature-card__body">{feature.body}</p>
              </Reveal>
            );
          })}
        </div>

        {/* Peekster — the differentiating feature, given extra emphasis */}
        <Reveal className="peekster" id="peekster">
          <div className="peekster__glow" aria-hidden="true" />
          <div className="peekster__content">
            <p className="eyebrow peekster__eyebrow">
              Meet Peekster
            </p>
            <h3 className="peekster__title">
              Your personal AI that watches your mood, not just the charts.
            </h3>
            <p className="peekster__body">
              Tell Peekster how you&apos;re feeling or what you&apos;re in the mood
              for, &ldquo;something cozy for a rainy night&rdquo; or &ldquo;a
              thriller that&apos;ll keep me guessing&rdquo; and get a
              personalized movie or TV pick in seconds.
            </p>

            <ul className="peekster__list">
              <li>Describe a mood, a vibe, or a plot in plain words</li>
              <li>Get recommendations tuned to your taste and your friends&apos;</li>
              <li>Never stare at an empty search bar again</li>
            </ul>

            <div className="peekster__cta">
              <AppStoreButton variant="primary" />
            </div>
          </div>

          <div className="peekster__visual">
            <PhoneMockup
              src={screen4}
              alt="Chat with Peekster, Peek's AI assistant, recommending movies based on the user's request"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
